import * as React from 'react';
import { IconButton, RadioGroup, UIHeading2, UIText3 } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

export interface IFutureYearPanelProps {
  selectedYear: number;
  years: number[];
  onChange(year: number): void;
  onClose(): void;
}

/** Панель таймлайна «Будущее района»: выбор года, на который показываются строящиеся объекты. */
export function FutureYearPanel({ selectedYear, years, onChange, onClose }: IFutureYearPanelProps): React.JSX.Element {
  const options = React.useMemo(
    () => years.map(year => ({ label: String(year), value: String(year) })),
    [years],
  );

  const handleChange = React.useCallback(
    (_event: React.ChangeEvent<HTMLInputElement>, value: string) => {
      onChange(Number(value));
    },
    [onChange],
  );

  return (
    <div className={styles['wrapper']} data-testid="district-infrastructure-map-future-years">
      <div className={styles['close-button']}>
        <IconButton
          aria-label="Закрыть"
          data-testid="district-infrastructure-map-future-close"
          icon={<IconActionClose16 />}
          onClick={onClose}
        />
      </div>
      <UIHeading2>Будущее района</UIHeading2>
      <div className={styles['subtitle']}>
        <UIText3 color="text-secondary-default">Данные на сегодняшний день</UIText3>
      </div>
      <div className={styles['years']}>
        <RadioGroup
          horizontal
          // ui-kit добавит к префиксу значение опции: district-infrastructure-map-future-year-2027.
          dataTestId="district-infrastructure-map-future-year"
          name="district-future-year"
          options={options}
          value={String(selectedYear)}
          onChange={handleChange}
        />
      </div>
    </div>
  );
}
